module.exports = __webpack_public_path__ + "img/3-weathervalve.e542eb94.png";